module.exports = __webpack_public_path__ + "img/mailing-service.1a2c6cf5.svg";